module.exports = __webpack_public_path__ + "img/footer-ph1.2f9c36f3.png";